import React, { useEffect, useState } from "react";
import { BrandIcon } from "@/components/BrandIcon";
import { api } from "@/lib/api";

export function useEnquirySources(includeInactive = false) {
  const [sources, setSources] = useState([]);
  const reload = () => api.get("/enquiry-sources", { params: { include_inactive: includeInactive } })
    .then((r) => setSources(r.data.sources || [])).catch(() => setSources([]));
  useEffect(() => { reload(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [includeInactive]);
  return [sources, reload];
}

export const SourceBadge = ({ name, testid }) => name ? (
  <span className="inline-flex items-center gap-1.5 rounded-md border border-slate-200 bg-white text-slate-700 pl-1.5 pr-2 py-0.5 text-xs font-medium whitespace-nowrap" data-testid={testid}>
    <BrandIcon name={name} size={16} testid={testid ? `${testid}-icon` : undefined} />{name}
  </span>
) : <span className="text-slate-300">—</span>;

export function EnquiryDetails({ details, source }) {
  const answers = (details?.answers || []).filter((a) => a.answer);
  if (!answers.length) return null;
  return (
    <div className="mb-4 rounded-xl border border-sky-100 bg-sky-50/50 p-4" data-testid="job-enquiry-details">
      <div className="flex items-center justify-between gap-2 mb-2">
        <h3 className="text-sm font-bold text-slate-900">Enquiry details</h3>
        <SourceBadge name={source} testid="job-enquiry-details-source" />
      </div>
      <dl className="grid grid-cols-1 sm:grid-cols-3 gap-3 text-sm">
        {answers.map((a) => (
          <div key={a.key} data-testid={`job-enquiry-answer-${a.key}`}>
            <dt className="text-xs font-medium text-slate-500">{a.question}</dt>
            <dd className="font-semibold text-slate-900">{a.answer}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
